module.exports = __webpack_public_path__ + "img/default.4a749e2d.png";